import lazyLoading from '@src/components/widgets/LazyLoading'
import { ACCESS } from '@src/configs/permission'
import { TRouteConfig } from '../routeConfig'

const PromotionCampaign = lazyLoading(() => import('@pages/promotion-campaign'))
const CreatePromotionCampaign = lazyLoading(() => import('@pages/promotion-campaign/create'))
const DetailPromotionCampaign = lazyLoading(() => import('@pages/promotion-campaign/detail'))
const ReportPromotionCampaign = lazyLoading(() => import('@pages/promotion-campaign/report'))
const ReportSaleOrderDetail = lazyLoading(() => import('@pages/promotion-campaign/report-sale-order-detail'))

export const promotionCampaignRouter: TRouteConfig[] = [
  {
    path: '/promotion-campaign',
    Element: PromotionCampaign,
    key: ACCESS.LIST_PROMOTION_CAMPAIGN,
  },
  {
    path: '/promotion-campaign/create',
    Element: CreatePromotionCampaign,
    key: ACCESS.ADD_PROMOTION_CAMPAIGN,
  },
  {
    path: '/promotion-campaign/:id',
    Element: DetailPromotionCampaign,
    key: ACCESS.VIEW_PROMOTION_CAMPAIGN,
  },
  {
    path: '/promotion-campaign/:id/edit',
    Element: CreatePromotionCampaign,
    key: ACCESS.EDIT_PROMOTION_CAMPAIGN,
  },
  {
    path: '/promotion-campaign/:id/report',
    Element: ReportPromotionCampaign,
    key: ACCESS.REPORT_PROMOTION_CAMPAIGN,
  },
  {
    path: '/promotion-campaign/report-sale-order-detail',
    Element: ReportSaleOrderDetail,
    key: ACCESS.REPORT_PROMOTION_CAMPAIGN,
  },
]
